module.exports = __webpack_public_path__ + "img/er.df14a128.svg";